var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#276EF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 18.4062L21.875 15.5938C21.5 15.2188 21 15 20.4688 15H17.9688C17.4375 15 16.9688 15.4688 16.9688 16V18.5C16.9688 19.0312 17.1875 19.5312 17.5625 19.9062L20.375 22.7188C20.7812 23.125 21.4062 23.125 21.8125 22.7188L24.6875 19.8438C25.0938 19.4375 25.0938 18.8125 24.6875 18.4062ZM18.9688 17.75C18.5625 17.75 18.2188 17.4375 18.2188 17C18.2188 16.5938 18.5625 16.25 18.9688 16.25C19.4062 16.25 19.7188 16.5938 19.7188 17C19.7188 17.4375 19.4062 17.75 18.9688 17.75ZM6.5 21.5V20.7188C6.5 19.2188 7.6875 18 9.1875 18C9.65625 18 10.375 18.5 12 18.5C13.5938 18.5 14.3125 18 14.7812 18C15.0312 18 15.25 18.0625 15.4688 18.125V16.5938C15.25 16.5312 15.0312 16.5 14.7812 16.5C13.875 16.5 13.4688 17 12 17C10.5 17 10.0938 16.5 9.1875 16.5C6.875 16.5 5 18.375 5 20.7188V21.5C5 22.3438 5.65625 23 6.5 23H17.5C17.7812 23 18.0625 22.9062 18.3125 22.75L17.0625 21.5H6.5ZM12 16C14.4688 16 16.5 14 16.5 11.5C16.5 9.03125 14.4688 7 12 7C9.5 7 7.5 9.03125 7.5 11.5C7.5 14 9.5 16 12 16ZM12 8.5C13.625 8.5 15 9.84375 15 11.5C15 13.1562 13.625 14.5 12 14.5C10.3438 14.5 9 13.1562 9 11.5C9 9.84375 10.3438 8.5 12 8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportManagementIcon);
export default __webpack_public_path__ + "static/media/support-management-icon.4fc737f68055a9ce7ebb002c427d3941.svg";
export { ForwardRef as ReactComponent };